import { apiFetch } from './client';

export const getStigSummary  = ()  => apiFetch('/stig/summary');
export const getLibraryStatus = () => apiFetch('/stig/library-status');
